import { get, post } from './_httpClient';

export async function getSurveyLeadershipIdentity() {
  return get('/clp/bumdes/survey-leadership/identity');
}

export async function getSurveyLeadershipQuestions() {
  return get('/clp/bumdes/survey-leadership/questions');
}

export async function saveDraftSurveyLeadership(payload) {
  return post('/clp/bumdes/survey-leadership/draft', payload);
}

export async function submitSurveyLeadership(payload) {
  return post('/clp/bumdes/survey-leadership/submit', payload);
}

export async function getSurveyLeadershipDashboard() {
  return get('/clp/bumdes/survey-leadership/dashboard');
}

export async function getSurveyLeadershipSummary({ batchId, provinceId }) {
  return get(
    `/clp/admin/bumdes/survey-leadership?batchId=${batchId}${
      provinceId ? `&provinceId=${provinceId}` : ''
    }`,
  );
}

export async function getSurveyLeadershipDetail({ userId, batchId }) {
  return get(
    `/clp/admin/bumdes/survey-leadership/${userId}?batchId=${batchId}`,
  );
}
